export const GRADING_TEAM_OPTIONS = [
  "RC DCD",
  "RC DEPLOYMENT",
  "RC PCB",
  "RC PC",
  "RC PRINTERS & PERIPHERALS",
  "RC MCD",
  "RC PED",
];

const SUPPORTED_TEAMS = new Set(GRADING_TEAM_OPTIONS);

export function normalizeGradingTeams(values) {
  const input = Array.isArray(values) ? values : [values];
  const seen = new Set();
  return input
    .map((value) => String(value || "").trim().toUpperCase())
    .filter((value) => {
      if (!SUPPORTED_TEAMS.has(value) || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
}

export function getEffectiveGradingTeams(row = {}) {
  const manual = normalizeGradingTeams(row.teams);
  if (manual.length) return manual;

  const legacy = String(row.team || "").trim().toUpperCase();
  return legacy ? [legacy] : [];
}

export function formatGradingTeams(values) {
  const teams = Array.isArray(values)
    ? values
    : getEffectiveGradingTeams({ team: values });
  return teams.filter(Boolean).join(", ");
}
